/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mobile-indicator': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<path pid="0" d="M7.5 2.138a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zm-3.89 1.61a.5.5 0 01.708 0l1.414 1.415a.5.5 0 11-.707.707L3.611 4.456a.5.5 0 010-.707H3.61zm7.78 0a.5.5 0 010 .708L9.974 5.87a.5.5 0 11-.707-.707l1.414-1.414a.5.5 0 01.707 0h.002zM2 7.638a.5.5 0 01.5-.5h2a.5.5 0 110 1h-2a.5.5 0 01-.5-.5zm6.64-.2A1 1 0 007 8.205v9.101c0 .924 1.145 1.354 1.753.66l2.026-2.317a1.5 1.5 0 011.129-.51h3.211c.935 0 1.359-1.17.64-1.769L8.64 7.437v.001zM8 17.308V8.205l7.119 5.933h-3.211a2.5 2.5 0 00-1.882.854L8 17.307v.001z" _fill="#999"/>'
  }
})
